// Chinese (Simplified) translations - 中文简体
export const zh: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': '加载中...',
  'common.error': '发生错误',
  'common.retry': '重试',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.continue': '继续',
  'common.back': '返回',
  'common.next': '下一步',
  'common.skip': '跳过',
  'common.done': '完成',
  'common.yes': '是',
  'common.no': '否',
  'common.ok': '确定',
  'common.check': '检查',
  'common.correct': '正确！',
  'common.incorrect': '错误',
  'common.tryAgain': '再试一次',
  'common.start': '开始',
  'common.finish': '结束',
  'common.submit': '提交',

  // ==================== NAVIGATION ====================
  'nav.home': '首页',
  'nav.courses': '课程',
  'nav.vocabulary': '词汇',
  'nav.profile': '个人资料',
  'nav.settings': '设置',
  'nav.logout': '退出登录',
  'nav.leaderboard': '排行榜',
  'nav.aiTutor': 'AI导师',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': '欢迎来到KoreanFlow！',
  'onboarding.selectLanguage': '选择您的语言',
  'onboarding.selectLanguageDesc': '选择应用界面语言',
  'onboarding.selectGoal': '您的学习目标是什么？',
  'onboarding.selectGoalDesc': '我们将为您定制学习路径',
  'onboarding.takeTest': '参加水平测试',
  'onboarding.takeTestDesc': '5分钟了解您的韩语水平',
  'onboarding.skipTest': '暂时跳过',
  'onboarding.skipTestDesc': '从头开始学习',
  'onboarding.letsGo': '开始吧！',
  'onboarding.step': '第',
  'onboarding.of': '步，共',

  // ==================== LEVEL TEST ====================
  'levelTest.title': '水平测试',
  'levelTest.subtitle': '让我们了解您的韩语水平',
  'levelTest.duration': '约5分钟',
  'levelTest.questions': '道题',
  'levelTest.vocabulary': '词汇',
  'levelTest.grammar': '语法',
  'levelTest.listening': '听力',
  'levelTest.speaking': '口语',
  'levelTest.analyzing': '正在分析您的结果...',
  'levelTest.yourLevel': '您的水平',
  'levelTest.congratulations': '恭喜！',
  'levelTest.resultDesc': '根据测试结果',
  'levelTest.startLearning': '开始学习',
  'levelTest.retakeTest': '重新测试',
  'levelTest.sectionComplete': '部分完成',
  'levelTest.nextSection': '下一部分',
  'levelTest.listenAndAnswer': '听并回答',
  'levelTest.speakNow': '请说话',
  'levelTest.tapToListen': '点击收听',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': '入门',
  'cefr.A2': '初级',
  'cefr.B1': '中级',
  'cefr.B2': '中高级',
  'cefr.C1': '高级',
  'cefr.C2': '精通',
  'cefr.A1.desc': '基本问候和简单表达',
  'cefr.A2.desc': '关于日常生活的简单对话',
  'cefr.B1.desc': '能应对大多数旅行情况',
  'cefr.B2.desc': '能与母语者流利交流',
  'cefr.C1.desc': '能流利自如地表达想法',
  'cefr.C2.desc': '在所有情况下接近母语水平',

  // ==================== LEAGUE / RANKING ====================
  'league.title': '联赛',
  'league.weeklyRanking': '周排名',
  'league.bronze': '青铜',
  'league.silver': '白银',
  'league.gold': '黄金',
  'league.platinum': '铂金',
  'league.diamond': '钻石',
  'league.promotion': '晋级区',
  'league.demotion': '降级区',
  'league.safe': '安全区',
  'league.weeklyXP': '本周经验值',
  'league.rank': '排名',
  'league.daysLeft': '天剩余',
  'league.promoted': '已晋级！',
  'league.demoted': '已降级',
  'league.stayed': '保级成功',
  'league.noData': '暂无排名数据',
  'league.earnXP': '获取经验值加入联赛！',
  'league.topPercent': '前{percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': '#1 韩语学习应用',
  'landing.title': '学习韩语',
  'landing.titleAccent': '轻松有趣',
  'landing.subtitle': '通过小课程、K-Pop和韩剧内容以及AI发音反馈掌握韩语。加入100万+学习者！',
  'landing.getStarted': '免费开始',
  'landing.learnMore': '了解更多',
  'landing.login': '登录',
  'landing.startFree': '免费开始',
  'landing.learners': '学习者',
  'landing.lessons': '课程',
  'landing.countries': '国家',

  // ==================== FEATURES ====================
  'features.title': '为什么选择KoreanFlow？',
  'features.subtitle': '我们独特的方法结合了游戏化、真实内容和AI技术，让韩语学习变得有趣而高效。',
  'features.streaks.title': '每日连续',
  'features.streaks.desc': '通过每日目标和连续奖励养成习惯。通过经验值和宝石保持动力。',
  'features.folksong.title': '民谣',
  'features.folksong.desc': '通过传统民谣学习韩语。理解歌词和文化！',
  'features.culture.title': '韩国文化',
  'features.culture.desc': '探索谚语、俚语和必备表达。掌握地道表达。',
  'features.ai.title': 'AI聊天机器人',
  'features.ai.desc': '与我们的AI导师练习对话。获得即时反馈和纠正。',
  'features.leaderboard.title': '排行榜',
  'features.leaderboard.desc': '与朋友和全球学习者竞争。攀登每周排名！',
  'features.srs.title': 'SRS词汇',
  'features.srs.desc': '智能重复系统确保您永远记住所学内容。',
  'features.pronunciation.title': '发音反馈',
  'features.pronunciation.desc': 'AI驱动的发音分析，提供详细评分。',

  // ==================== CTA ====================
  'cta.title': '准备开始您的旅程了吗？',
  'cta.subtitle': '加入数百万学习者，今天就开始说韩语。免费！',
  'cta.button': '免费开始学习',

  // ==================== AUTH ====================
  'auth.login': '登录',
  'auth.register': '注册',
  'auth.email': '邮箱',
  'auth.emailPlaceholder': '输入您的邮箱',
  'auth.password': '密码',
  'auth.passwordPlaceholder': '创建密码',
  'auth.confirmPassword': '确认密码',
  'auth.forgotPassword': '忘记密码？',
  'auth.noAccount': '没有账户？',
  'auth.haveAccount': '已有账户？',
  'auth.orContinueWith': '或继续使用',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': '创建账户',
  'auth.createAccountTitle': '创建您的账户',
  'auth.createAccountSubtitle': '今天开始您的韩语学习之旅',
  'auth.username': '用户名',
  'auth.usernamePlaceholder': '选择用户名',
  'auth.usernameHint': '只能使用字母、数字和下划线',
  'auth.passwordHint': '至少8个字符，包含大写、小写和数字',
  'auth.nativeLanguage': '母语',
  'auth.nativeLanguageHint': '我们将用这种语言显示解释',
  'auth.termsAgree': '注册即表示您同意我们的',
  'auth.terms': '条款',
  'auth.and': '和',
  'auth.privacyPolicy': '隐私政策',
  'auth.loginTitle': '欢迎回来',
  'auth.loginSubtitle': '登录以继续学习',
  'auth.loginButton': '登录',
  'auth.registerButton': '注册',
  'auth.rememberMe': '记住我',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': '欢迎回来',
  'dashboard.todayGoal': '今日目标',
  'dashboard.streak': '连续',
  'dashboard.days': '天',
  'dashboard.xp': '经验值',
  'dashboard.level': '等级',
  'dashboard.continueLearning': '继续学习',
  'dashboard.recommended': '为您推荐',
  'dashboard.myCourses': '我的课程',
  'dashboard.seeAll': '查看全部',
  'dashboard.dailyGoalComplete': '每日目标完成！',
  'dashboard.keepGoing': '继续加油！',
  'dashboard.yourLevel': '您的水平',
  'dashboard.weeklyProgress': '本周进度',

  // ==================== COURSES ====================
  'courses.title': '全部课程',
  'courses.search': '搜索课程...',
  'courses.all': '全部',
  'courses.beginner': '入门',
  'courses.elementary': '初级',
  'courses.intermediate': '中级',
  'courses.advanced': '高级',
  'courses.lessons': '课时',
  'courses.enrolled': '已注册',
  'courses.progress': '进度',
  'courses.completed': '已完成',
  'courses.recommended': '推荐',
  'courses.forYourLevel': '适合您的水平',
  'courses.locked': '已锁定',
  'courses.unlockWith': '升级解锁',

  // ==================== LESSON ====================
  'lesson.loading': '加载课程...',
  'lesson.notFound': '未找到课程',
  'lesson.quit': '确定要退出吗？您的进度将丢失。',
  'lesson.complete': '课程完成！',
  'lesson.perfect': '完美！',
  'lesson.amazing': '太棒了！您全部答对了！',
  'lesson.xpEarned': '获得经验值',
  'lesson.accuracy': '正确率',
  'lesson.correct': '正确',
  'lesson.goBack': '返回',
  'lesson.skip': '跳过',
  'lesson.unknownType': '未知练习类型',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': '点击显示答案',
  'exercise.matchPairs': '配对练习',
  'exercise.matched': '已匹配',
  'exercise.arrangeWords': '排列单词',
  'exercise.speak': '说',
  'exercise.listening': '正在听...请说话！',
  'exercise.processing': '正在处理您的语音...',
  'exercise.tapToSpeak': '点击说话',
  'exercise.cantSpeak': '现在不方便说话？跳过',
  'exercise.again': '再来一次',
  'exercise.gotIt': '明白了！',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': '发音练习',
  'pronunciation.subtitle': '通过AI反馈提高您的韩语发音',
  'pronunciation.selectLevel': '选择您的水平',
  'pronunciation.beginner': '入门',
  'pronunciation.intermediate': '中级',
  'pronunciation.advanced': '高级',
  'pronunciation.score': '您的分数',
  'pronunciation.accuracy': '准确度',
  'pronunciation.fluency': '流利度',
  'pronunciation.intonation': '语调',
  'pronunciation.feedback': '反馈',
  'pronunciation.tryAgain': '再试一次',
  'pronunciation.next': '下一个',
  'pronunciation.listen': '听',
  'pronunciation.slow': '慢速',
  'pronunciation.sessionComplete': '练习完成！',
  'pronunciation.bestScore': '最高分',
  'pronunciation.average': '平均分',
  'pronunciation.attempts': '尝试次数',
  'pronunciation.practiceAgain': '再次练习',
  'pronunciation.changeLevel': '更改水平',
  'pronunciation.tips': '发音技巧',
  'pronunciation.tip1': '先听音频',
  'pronunciation.tip2': '清晰、匀速地说',
  'pronunciation.tip3': '难词使用慢速播放',
  'pronunciation.tip4': '在安静的环境中练习',

  // ==================== VOCABULARY ====================
  'vocab.title': '词汇',
  'vocab.totalWords': '总词数',
  'vocab.mastered': '已掌握',
  'vocab.dueToday': '今日待复习',
  'vocab.reviewSession': '复习环节',
  'vocab.wordsDue': '个词待复习',
  'vocab.startReview': '开始复习',
  'vocab.allCaughtUp': '全部完成！',
  'vocab.noWordsDue': '没有待复习的词',
  'vocab.sessionComplete': '复习完成！',
  'vocab.allWords': '所有词汇',

  // ==================== PROFILE ====================
  'profile.title': '个人资料',
  'profile.level': '等级',
  'profile.xpToNext': '距下一级',
  'profile.totalXp': '总经验值',
  'profile.currentStreak': '当前连续',
  'profile.lessonsDone': '已完成课程',
  'profile.timeLearned': '学习时长',
  'profile.achievements': '成就',
  'profile.settings': '设置',
  'profile.dailyGoals': '每日目标',
  'profile.allAchievements': '所有成就',
  'profile.logOut': '退出登录',
  'profile.koreanLevel': '韩语水平',

  // ==================== SETTINGS ====================
  'settings.title': '设置',
  'settings.language': '应用语言',
  'settings.preferences': '偏好设置',
  'settings.sound': '音效',
  'settings.soundEffects': '音效',
  'settings.soundEffectsDesc': '答题时播放音效',
  'settings.notifications': '通知',
  'settings.notificationsDesc': '接收每日学习提醒',
  'settings.darkMode': '深色模式',
  'settings.darkModeDesc': '深色主题，阅读更舒适',
  'settings.dailyReminder': '每日提醒',
  'settings.account': '账户',
  'settings.editProfile': '编辑资料',
  'settings.privacy': '隐私',
  'settings.help': '帮助',
  'settings.about': '关于',
  'settings.retakeTest': '重新测试水平',
  'settings.retakeTestDesc': '检查您目前的韩语水平',
  'settings.terms': '服务条款',

  // ==================== FOOTER ====================
  'footer.privacy': '隐私',
  'footer.terms': '条款',
  'footer.contact': '联系',
  'footer.rights': '版权所有。',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': '词汇',
  'quickAction.reviewWords': '复习词汇',
  'quickAction.allCourses': '全部课程',
  'quickAction.browseLessons': '浏览课程',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': '未找到课程',
  'courseDetail.lessons': '课时',
  'courseDetail.completed': '已完成',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': '首页',
  'bottomNav.courses': '课程',
  'bottomNav.vocab': '词汇',
  'bottomNav.profile': '我的',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'AI导师',
  'aiTutor.selectScenario': '选择场景',
  'aiTutor.freeTalk': '自由对话',
  'aiTutor.cafe': '咖啡店点单',
  'aiTutor.shopping': '购物',
  'aiTutor.restaurant': '餐厅',
  'aiTutor.friends': '交朋友',
  'aiTutor.interview': '求职面试',
  'aiTutor.typeMessage': '输入消息...',
  'aiTutor.send': '发送',

  // ==================== ERRORS ====================
  'error.generic': '出了点问题',
  'error.network': '网络错误。请检查您的连接。',
  'error.notFound': '页面未找到',
  'error.unauthorized': '请登录以继续',
  'error.microphoneAccess': '麦克风访问被拒绝',
  'error.speechNotSupported': '不支持语音识别。请尝试Chrome浏览器。',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': '我们使用Cookie',
  'cookie.description': '我们使用Cookie来改善您的体验、分析网站流量和个性化内容。您可以选择接受或拒绝非必要Cookie。',
  'cookie.learnMore': '了解更多',
  'cookie.acceptAll': '全部接受',
  'cookie.rejectAll': '全部拒绝',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': '学习',
  'nav.culture': '文化',
  'nav.chat': '对话',
  'nav.ranking': '排行榜',
  'nav.family': '家庭',
  'nav.premium': '会员',
  'home.greeting': '你好',
  'home.streak': '天连续打卡',
  'home.dailyGoal': '每日目标',
  'home.myLanguages': '我的语言',
  'home.addLanguage': '添加语言',
  'home.recommended': '推荐',
  'home.continue': '继续学习',
  'home.selectLanguage': '选择语言',
  'home.totalXp': '总经验值',
  'home.bestStreak': '最长连续',
  'home.level': '等级',
  'chat.aiTutor': 'AI 导师',
  'chat.aiTutorDesc': '与 AI 练习对话',
  'onboarding.welcome.subtitle': '用 AI 对话学习任何语言',
  'onboarding.selectUILanguage': '选择你的语言',
  'onboarding.selectUILanguage.subtitle': '将用于应用界面',
  'onboarding.selectLearningLanguage': '你想学什么？',
  'onboarding.selectLearningLanguage.subtitle': '你可以学习多种语言',
  'onboarding.selectDailyGoal': '设定每日目标',
  'onboarding.selectDailyGoal.subtitle': '你每天能投入多少时间？',
  'onboarding.ready': '一切就绪！',
  'onboarding.ready.subtitle': '开启你的语言学习之旅吧',
  'onboarding.features.languages': '4 种语言',
  'onboarding.features.aiTutor': 'AI 导师',
  'onboarding.features.dailyGoals': '每日目标',
  'dailyGoal.5min': '5 分钟',
  'dailyGoal.10min': '10 分钟',
  'dailyGoal.15min': '15 分钟',
  'dailyGoal.20min': '20 分钟',
  'dailyGoal.casual': '轻松节奏',
  'dailyGoal.regular': '常规练习',
  'dailyGoal.serious': '认真学习',
  'dailyGoal.intense': '强化训练',
  'learn.title': '学习',
  'learn.currentLevel': '当前等级',
  'learn.noCoursesYet': '敬请期待！',
  'learn.noCoursesDescription': '该语言的课程正在准备中。',
  'learn.lessonsCompleted': '节课已完成',
  'learn.startCourse': '开始课程',
  'learn.continueCourse': '继续',
  'learn.courseCompleted': '已完成',
  'learn.locked': '已锁定',
  'learn.unlockBy': '完成上一课程即可解锁',
  'course.progress': '进度',
  'course.lessons': '课程',
  'course.lessonsCompleted': '节课已完成',
  'course.noLessons': '课程正在准备中…',
  'lesson.tapToReveal': '点击查看释义',
  'lesson.examples': '例句',
  'lesson.questionsCorrect': '正确',
  'lesson.wordsLearned': '单词',
  'lesson.grammarPoints': '语法',
  'lesson.backToCourse': '返回课程',
  'lesson.practiceAgain': '再次练习',
  'lesson.whatYouLearn': '你将学到',
  'lesson.newWords': '个新单词',
  'lesson.exercises': '道练习',
  'lesson.startLesson': '开始学习',
  'lesson.reviewLesson': '复习课程',
  'lesson.learnVocabulary': '学习词汇',
  'lesson.grammarPoint': '语法点',
  'lesson.practice': '练习',
  'profile.guest': '访客',
  'profile.days': '天',
  'profile.longestStreak': '最长',
  'profile.lessonsCompleted': '已完成',
  'profile.dailyGoal': '每日目标',
  'profile.learningLanguages': '学习语言',
  'profile.noLanguages': '未选择语言',
  'profile.minutesPerDay': '分钟/天',
  'profile.learningHistory': '学习记录',
  'profile.viewProgress': '查看你的进度',
  'profile.appSettings': '应用设置',
  'profile.languageNotifications': '语言、通知',
  'profile.loginToSave': '登录以保存学习进度',
  'settings.learning': '学习',
  'settings.dailyGoal': '每日目标',
  'settings.minutesPerDay': '分钟/天',
  'settings.selectLanguage': '选择语言',
  'settings.selectDailyGoal': '设定每日目标',
  'settings.perDay': '每天',
  'settings.appInfo': '应用信息',
  'settings.logout': '退出登录',
};

export default zh;
